import { createVanIconComponent } from "./van"

const Share = createVanIconComponent("share")
export default Share
